// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

const BADGES_COLORS = {
  '6': '#A9AEB1',
  '7': '#5D9BFF',
  '9': '#CB8888',
  '10': '#FFAC7F',
  '11': '#E7F0FF',
  '12': '#FFC514',
};

const Span = styled.span`
  display: inline-block;
  margin: 2px;
`;

const Border = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${({ $type }) => BADGES_COLORS[$type] || BADGES_COLORS[6]};
  border: solid 2px ${({ theme }) => theme.grids.colors.black};
`;

const Center = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  font-size: 12px;
  border-radius: 50%;
  background: ${({ theme }) => theme.grids.colors.black};
  color: ${({ $type }) => BADGES_COLORS[$type] || BADGES_COLORS[6]};
  border: solid 1px ${({ $type }) => BADGES_COLORS[$type] || BADGES_COLORS[6]};
  text-align: center;
`;

type Props = {
  className?: string;
  type: number;
};

const Badge = ({ className, type }: Props) => (
  <Span>
    <Border className={className} $type={type}>
      <Center $type={type}>{type}</Center>
    </Border>
  </Span>
);

export default Badge;
